module.exports = __webpack_public_path__ + "img/phone.6af8cde9.svg";